import "../styles/index.css";
import React, { useEffect, useState } from "react";
import HelpIcon from "./HelpIcon";
import Container from "./Container";
import { useCustomer } from "../utils/use-customer";
import CustomerForm from "./CustomerForm";
import MessageForm from "./MessageForm";
import { useConfig } from "../utils/use-config";

type Props = {};

const Widget: React.FC<Props> = ({}) => {
  const { customerData, launchSelector, debug } = useConfig();
  const { customerToken } = useCustomer();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (debug) {
      console.log("[Widget] useEffect setting up launch handler");
    }
    function launchHandler(event: any): void {
      if (debug) {
        console.log("[Widget] launchHandler being called");
      }
      if (
        launchSelector &&
        launchSelector.length > 0 &&
        event.target?.matches(launchSelector)
      ) {
        event.preventDefault();
        // event.stopPropagation();

        if (debug) {
          console.log(
            "[Widget] launchHandler matches selector, opening widget"
          );
        }

        setOpen(true);
      }
    }

    document.addEventListener("click", launchHandler, false);

    return () => {
      // remove the event listeners
      document.removeEventListener("click", launchHandler, false);
    };
  }, [launchSelector, debug]);

  return (
    <div
      className={`hw-happi-widget hw-fixed hw-inset-x-4 hw-bottom-4 md:hw-inset-x-8 md:hw-bottom-8 hw-flex hw-flex-col hw-items-end hw-z-50`}
    >
      {open && (
        <Container onClose={() => setOpen(false)}>
          {customerToken === null && !customerData ? (
            <CustomerForm />
          ) : (
            <MessageForm />
          )}
        </Container>
      )}
      <HelpIcon onClick={() => setOpen(!open)} />
    </div>
  );
};

export default Widget;
